import { inject, bindable } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { AccountAPI } from 'services/accountAPI';


@inject(AuthService, Router, UserMessageService, AccountAPI)

export class VendastaLogin {
   
    constructor(authService, router, userMessageService, accountApi) {

        this.authService = authService;
        this.router = router;

        this.userMessageService = userMessageService;

        this.recover_password = false;

        this.accountApi = accountApi;
    }

    activate(model) {
        
        this.email = '';
        this.password = '';
        this.password1 = '';
        this.password2 = '';
        this.confirmToken = model.confirm_token;
        this.resetToken = model.reset_token;
        this.redirectUrl = model.url;

        this.vendasta_user = model.us;
        this.vendasta_account_id = model.acc_id;
        this.vendasta_product_id = model.p_id;
        //console.log(model.us);return false;

        if(localStorage['magnfi_username'])
            this.email = localStorage['magnfi_username'];

        this.accountApi.verify_vendasta_user({legacy_user_id:this.vendasta_user, account_id:this.vendasta_account_id,p_id:this.vendasta_product_id}, this.vendasta_user_success.bind(this), this.vendasta_user_error.bind(this));

        //this.authService.login("ahanif@cinnova.com", "12345", this.confirmToken, this.redirectUrl, this.vendasta_user);    
       
    }
    vendasta_user_success(data){
        
        console.log('tp_user_success');
        console.log(data.is_verified);
        //reset the vendasta items
        localStorage.setItem('tp_nav_url', '');
        localStorage.setItem('tp_app_id', '');
        localStorage.setItem('tp_account_id', '');
        //reset the vendasta items    
        if(data.is_verified && data.is_active == "Y"){
            
            console.log('T, vendasta user details');
            console.log(data);
            localStorage.setItem('tp_nav_url', data.nav_url);
            localStorage.setItem('tp_app_id', data.app_id);
            localStorage.setItem('tp_account_id', data.vendasta_account_id);
            localStorage.setItem('tp_product_id', data.vendasta_product_id);
            
            this.authService.login(data.email, "12345", this.confirmToken, this.redirectUrl, this.vendasta_user, this.vendasta_account_id, this.vendasta_product_id);
        } else{
            console.log('F');
            //???header('Location: '. $this->site_url . '/#/visitor/tpError?error=101');exit;
            this.router.navigate("#/visitor/tpError?error=101");
        }
    }
    vendasta_user_error(data){
        console.log('tp_user_error');
        console.log(data);
    }
    login() {
        if(this.validateLogin()) {
            this.authService.login(this.email, this.password, this.confirmToken, this.redirectUrl);
        }
    }

    recoverPassword() {
        if(this.validateRecoverPassword()) {
            this.authService.sendPasswordReset(this.email);
        }
    }

    resetPassword() {
        if(this.validateResetPassword()) {
            this.authService.loginWithResetPassword(this.email, this.password1, this.resetToken);
        }
    }

    showRecoverPassword() {
        this.recover_password = true;
    }


    handleKeypress(event) {
        if (event.keyCode == 13) {
            if(this.resetToken != null)
                this.resetPassword();
            else if(this.recover_password && this.resetToken == null)
                this.recoverPassword();
            else 
                this.login();
            //event.preventDefault();
            return false;
             
        }
       
       return true;
    }

    validateLogin() {
        var pass = true;
        
        if (this.email == null || this.email.trim() == '') {
            this.userMessageService.setUserError("login", "Email is empty");
            pass = false;
        }

        if (this.password == null || this.password.trim() == '') {
            this.userMessageService.setUserError("login", "Password is empty");
            pass = false;
        }

        return pass;

    }

    validateRecoverPassword() {
        var pass = true;
        
        if (this.email == null || this.email.trim() == '') {
            this.userMessageService.setUserError("login", "Email is empty");
            pass = false;
        }

        return pass;

    }

    validateResetPassword() {
        var pass = true;
        
        if (this.email == null || this.email.trim() == '') {
            this.userMessageService.setUserError("login", "Email is empty");
            pass = false;
        }

        if(this.password1 == null || this.password1.trim() == '' || this.password2 == null || this.password2.trim() == '') {
            this.userMessageService.setUserError("login", "Password is empty");
            pass = false;
        }

        if(this.password1 != this.password2) {
            this.userMessageService.setUserError("login", "Passwords do not match");
            pass = false;
        }

        return pass;

    }

}
